export default __webpack_public_path__ + "static/media/IPOIcon.bd3a0e64.svg";